// This file is auto-generated by scripts/generate-models.ts
// Do not edit manually - run 'npm run generate-models' to update

import { AMAZON_BEDROCK_MODELS } from "./providers/amazon-bedrock.models.ts";
import { ANT_LING_MODELS } from "./providers/ant-ling.models.ts";
import { ANTHROPIC_MODELS } from "./providers/anthropic.models.ts";
import { AZURE_OPENAI_RESPONSES_MODELS } from "./providers/azure-openai-responses.models.ts";
import { CEREBRAS_MODELS } from "./providers/cerebras.models.ts";
import { CLOUDFLARE_AI_GATEWAY_MODELS } from "./providers/cloudflare-ai-gateway.models.ts";
import { CLOUDFLARE_WORKERS_AI_MODELS } from "./providers/cloudflare-workers-ai.models.ts";
import { DEEPSEEK_MODELS } from "./providers/deepseek.models.ts";
import { FIREWORKS_MODELS } from "./providers/fireworks.models.ts";
import { GITHUB_COPILOT_MODELS } from "./providers/github-copilot.models.ts";
import { GOOGLE_MODELS } from "./providers/google.models.ts";
import { GOOGLE_VERTEX_MODELS } from "./providers/google-vertex.models.ts";
import { GROQ_MODELS } from "./providers/groq.models.ts";
import { HUGGINGFACE_MODELS } from "./providers/huggingface.models.ts";
import { KIMI_CODING_MODELS } from "./providers/kimi-coding.models.ts";
import { MINIMAX_MODELS } from "./providers/minimax.models.ts";
import { MINIMAX_CN_MODELS } from "./providers/minimax-cn.models.ts";
import { MISTRAL_MODELS } from "./providers/mistral.models.ts";
import { MOONSHOTAI_MODELS } from "./providers/moonshotai.models.ts";
import { MOONSHOTAI_CN_MODELS } from "./providers/moonshotai-cn.models.ts";
import { NVIDIA_MODELS } from "./providers/nvidia.models.ts";
import { OPENAI_MODELS } from "./providers/openai.models.ts";
import { OPENAI_CODEX_MODELS } from "./providers/openai-codex.models.ts";
import { OPENCODE_MODELS } from "./providers/opencode.models.ts";
import { OPENCODE_GO_MODELS } from "./providers/opencode-go.models.ts";
import { OPENROUTER_MODELS } from "./providers/openrouter.models.ts";
import { QWEN_TOKEN_PLAN_MODELS } from "./providers/qwen-token-plan.models.ts";
import { QWEN_TOKEN_PLAN_CN_MODELS } from "./providers/qwen-token-plan-cn.models.ts";
import { TOGETHER_MODELS } from "./providers/together.models.ts";
import { VERCEL_AI_GATEWAY_MODELS } from "./providers/vercel-ai-gateway.models.ts";
import { XAI_MODELS } from "./providers/xai.models.ts";
import { XIAOMI_MODELS } from "./providers/xiaomi.models.ts";
import { XIAOMI_TOKEN_PLAN_AMS_MODELS } from "./providers/xiaomi-token-plan-ams.models.ts";
import { XIAOMI_TOKEN_PLAN_CN_MODELS } from "./providers/xiaomi-token-plan-cn.models.ts";
import { XIAOMI_TOKEN_PLAN_SGP_MODELS } from "./providers/xiaomi-token-plan-sgp.models.ts";
import { ZAI_MODELS } from "./providers/zai.models.ts";
import { ZAI_CODING_CN_MODELS } from "./providers/zai-coding-cn.models.ts";

export const MODELS: {
	readonly "amazon-bedrock": typeof AMAZON_BEDROCK_MODELS;
	readonly "ant-ling": typeof ANT_LING_MODELS;
	readonly "anthropic": typeof ANTHROPIC_MODELS;
	readonly "azure-openai-responses": typeof AZURE_OPENAI_RESPONSES_MODELS;
	readonly "cerebras": typeof CEREBRAS_MODELS;
	readonly "cloudflare-ai-gateway": typeof CLOUDFLARE_AI_GATEWAY_MODELS;
	readonly "cloudflare-workers-ai": typeof CLOUDFLARE_WORKERS_AI_MODELS;
	readonly "deepseek": typeof DEEPSEEK_MODELS;
	readonly "fireworks": typeof FIREWORKS_MODELS;
	readonly "github-copilot": typeof GITHUB_COPILOT_MODELS;
	readonly "google": typeof GOOGLE_MODELS;
	readonly "google-vertex": typeof GOOGLE_VERTEX_MODELS;
	readonly "groq": typeof GROQ_MODELS;
	readonly "huggingface": typeof HUGGINGFACE_MODELS;
	readonly "kimi-coding": typeof KIMI_CODING_MODELS;
	readonly "minimax": typeof MINIMAX_MODELS;
	readonly "minimax-cn": typeof MINIMAX_CN_MODELS;
	readonly "mistral": typeof MISTRAL_MODELS;
	readonly "moonshotai": typeof MOONSHOTAI_MODELS;
	readonly "moonshotai-cn": typeof MOONSHOTAI_CN_MODELS;
	readonly "nvidia": typeof NVIDIA_MODELS;
	readonly "openai": typeof OPENAI_MODELS;
	readonly "openai-codex": typeof OPENAI_CODEX_MODELS;
	readonly "opencode": typeof OPENCODE_MODELS;
	readonly "opencode-go": typeof OPENCODE_GO_MODELS;
	readonly "openrouter": typeof OPENROUTER_MODELS;
	readonly "qwen-token-plan": typeof QWEN_TOKEN_PLAN_MODELS;
	readonly "qwen-token-plan-cn": typeof QWEN_TOKEN_PLAN_CN_MODELS;
	readonly "together": typeof TOGETHER_MODELS;
	readonly "vercel-ai-gateway": typeof VERCEL_AI_GATEWAY_MODELS;
	readonly "xai": typeof XAI_MODELS;
	readonly "xiaomi": typeof XIAOMI_MODELS;
	readonly "xiaomi-token-plan-ams": typeof XIAOMI_TOKEN_PLAN_AMS_MODELS;
	readonly "xiaomi-token-plan-cn": typeof XIAOMI_TOKEN_PLAN_CN_MODELS;
	readonly "xiaomi-token-plan-sgp": typeof XIAOMI_TOKEN_PLAN_SGP_MODELS;
	readonly "zai": typeof ZAI_MODELS;
	readonly "zai-coding-cn": typeof ZAI_CODING_CN_MODELS;
} = {
	"amazon-bedrock": AMAZON_BEDROCK_MODELS,
	"ant-ling": ANT_LING_MODELS,
	"anthropic": ANTHROPIC_MODELS,
	"azure-openai-responses": AZURE_OPENAI_RESPONSES_MODELS,
	"cerebras": CEREBRAS_MODELS,
	"cloudflare-ai-gateway": CLOUDFLARE_AI_GATEWAY_MODELS,
	"cloudflare-workers-ai": CLOUDFLARE_WORKERS_AI_MODELS,
	"deepseek": DEEPSEEK_MODELS,
	"fireworks": FIREWORKS_MODELS,
	"github-copilot": GITHUB_COPILOT_MODELS,
	"google": GOOGLE_MODELS,
	"google-vertex": GOOGLE_VERTEX_MODELS,
	"groq": GROQ_MODELS,
	"huggingface": HUGGINGFACE_MODELS,
	"kimi-coding": KIMI_CODING_MODELS,
	"minimax": MINIMAX_MODELS,
	"minimax-cn": MINIMAX_CN_MODELS,
	"mistral": MISTRAL_MODELS,
	"moonshotai": MOONSHOTAI_MODELS,
	"moonshotai-cn": MOONSHOTAI_CN_MODELS,
	"nvidia": NVIDIA_MODELS,
	"openai": OPENAI_MODELS,
	"openai-codex": OPENAI_CODEX_MODELS,
	"opencode": OPENCODE_MODELS,
	"opencode-go": OPENCODE_GO_MODELS,
	"openrouter": OPENROUTER_MODELS,
	"qwen-token-plan": QWEN_TOKEN_PLAN_MODELS,
	"qwen-token-plan-cn": QWEN_TOKEN_PLAN_CN_MODELS,
	"together": TOGETHER_MODELS,
	"vercel-ai-gateway": VERCEL_AI_GATEWAY_MODELS,
	"xai": XAI_MODELS,
	"xiaomi": XIAOMI_MODELS,
	"xiaomi-token-plan-ams": XIAOMI_TOKEN_PLAN_AMS_MODELS,
	"xiaomi-token-plan-cn": XIAOMI_TOKEN_PLAN_CN_MODELS,
	"xiaomi-token-plan-sgp": XIAOMI_TOKEN_PLAN_SGP_MODELS,
	"zai": ZAI_MODELS,
	"zai-coding-cn": ZAI_CODING_CN_MODELS,
};
